import { render, staticRenderFns } from "./comment-form.vue?vue&type=template&id=5595aa82&lang=pug&"
import script from "./comment-form.vue?vue&type=script&lang=js&"
export * from "./comment-form.vue?vue&type=script&lang=js&"
import style0 from "./comment-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5595aa82')) {
      api.createRecord('5595aa82', component.options)
    } else {
      api.reload('5595aa82', component.options)
    }
    module.hot.accept("./comment-form.vue?vue&type=template&id=5595aa82&lang=pug&", function () {
      api.rerender('5595aa82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comment-form.vue"
export default component.exports